import { render, staticRenderFns } from "./DeliveryError.vue?vue&type=template&id=a82c5f34&"
import script from "./DeliveryError.vue?vue&type=script&lang=js&"
export * from "./DeliveryError.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports